import { useTollingPointNamesLazyQuery } from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useCallback } from 'react';

export const useTollingPointNamesDataSource = (): DataSource<FormOption[]> => {
  const [getTollingPointNames] = useTollingPointNamesLazyQuery({
    variables: {
      limit: 10000,
    },
  });

  const load = useCallback(async () => {
    const { data } = await getTollingPointNames();
    const tollingPointOptions = getNodes(data?.tollingPoints).map((tollingPoint) => ({
      label: tollingPoint.name,
      value: tollingPoint.id,
    }));

    return tollingPointOptions as FormOption[];
  }, [getTollingPointNames]);

  return { load };
};
